<template>
  <div class="app-container">
    <el-skeleton v-if="pageLoading" :rows="12" animated />
    <div v-else class="form-box">
      <el-form
        label-position="left"
        ref="form"
        :rules="rules"
        :model="form"
        label-width="92px"
      >
        <el-form-item label="微信号" prop="wechat">
          <el-input v-model="form.wechat" placeholder="请输入微信号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="phone">
          <el-input
            type="email"
            v-model="form.phone"
            placeholder="请输入电子邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信二维码(220*220)" prop="wechat_qrcode">
          <upload-one
            v-model="form.wechat_qrcode"
            width="250px"
            height="250px"
          ></upload-one>
        </el-form-item>


        <el-form-item label="弹窗小助手二维码(300*300)" prop="popUpImg_qrcode">
          <upload-one
            v-model="form.popUpImg_qrcode"
            width="250px"
            height="250px"
          ></upload-one>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="saving" @click="onSave('form')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 客服资料
import request from "@/utils/request";

export default {
  data: () => ({
    rules: {
      wechat: [{ required: true, message: "请输入微信号", trigger: "blur" }],
      phone: [
        {
          required: true,
          message: "请输入电子邮箱",
          trigger: "blur",
        },
        {
          type: "email",
          message: "请输入正确的邮箱地址",
        },
      ],
      wechat_qrcode: [
        { required: true, message: "请上传二维码", trigger: "blur" },
      ],
      popUpImg_qrcode: [
        { required: true, message: "请上传二维码", trigger: "blur" },
      ],
    },
    form: {
      wechat: "",
      phone: "",
      wechat_qrcode: null,
      popUpImg_qrcode: null,
    },
    videoType: ["mp4", "rmvb", "wmv", "avi", "mov", "flv"],
    pageLoading: true,
    saving: false,
  }),
  methods: {
    getProfile() {
      request({
        url: "/api/backend/settings",
        method: "get",
        params: {
          system_logs_content: "基础管理-客服资料-查看",
          prefix: "kefu",
        },
      }).then((res) => {
        const [wechat, phone, wechat_qrcode, popUpImg_qrcode] = res.data.data;
        this.form.wechat = wechat ? wechat.value || "" : ""; //微信号
        this.form.phone = phone ? phone.value || "" : ""; //二维码
        this.form.wechat_qrcode = wechat_qrcode ? wechat_qrcode.value || "" : ""; //电话
        this.form.popUpImg_qrcode = popUpImg_qrcode ? popUpImg_qrcode.value || "" : ""; //
        this.pageLoading = false;
      });
    },
    onSave(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {

            let videoFlag = this.videoType.indexOf(
              this.form.popUpImg_qrcode.substring(this.form.popUpImg_qrcode.lastIndexOf(".") + 1)
              ) == -1 ?  false : true
            if(videoFlag) {
              this.form.popUpImg_qrcode = ''
              return this.$message.error('不可上传视频，请上传图片')
            }

          try {


            this.saving = true;
            await request({
              url: "/api/backend/settings/store",
              method: "post",
              data: {
                "kefu.wx": {
                  value: this.form.wechat,
                },
                "kefu.phone": {
                  value: this.form.phone,
                },
                "kefu.wximg": {
                  value: this.form.wechat_qrcode,
                },
                "kefu.popUpImg": {
                  value: this.form.popUpImg_qrcode,
                },
              },
            });
            this.$message({
              message: "已保存!",
              type: "success",
            });
          } catch {
            this.$message.error("出错了!");
          } finally {
            this.saving = false;
          }
        }
      });
    },
  },
  beforeMount() {
    this.getProfile();
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  max-width: 512px;
}
</style>
